const PAYONSITE = 'PAYONSITE';
const VPC = 'VPC';

export const CARD_TYPES_TREATMENT = {
  [PAYONSITE]: VPC,
};
